import React from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import { FastField, FieldProps } from 'formik';

import ActionPropertiesField from 'core/dashboard/components/widgets/common/config/formik/ActionPropertiesField';
import { ShowPageActionConfig } from 'core/dashboard/types/actionHandlerTypes';
import EvaluatableFieldComponent from 'core/dashboard/components/form/formik/EvaluatableFieldComponent';

/**
 * Configuration for the show-page action
 */

export default function ShowPageActionInput(props: FieldProps) {
    const { field } = props;
    const name = field.name;
    const config = field.value as ShowPageActionConfig;
    const params = config.params;

    return (
        <div className="action-config">
            <Form.Group as={Row}>
                <Col xs={3}>URL</Col>
                <Col xs={9}>
                    <FastField name={name + '.url'} component={EvaluatableFieldComponent}/>
                </Col>
            </Form.Group>
            <Form.Group as={Row}>
                <Col xs={3}>Params</Col>
                <Col xs={9}>
                    <ActionPropertiesField name={name + '.params'} properties={params}/>
                </Col>
            </Form.Group>
        </div>
    );
}
